import { connect } from 'react-redux';
import withPGTranslation from '@app/config/withPGTranslation';
import { QuickTopupBanner } from './quick_topup_banner';

const mapStateToProps = ({ topup, chat: { state } }: { topup: object, chat: { state: string } }) => ({
  ...topup,
  chatState: state
});

export default connect(mapStateToProps)(withPGTranslation(QuickTopupBanner));
